/**
 * @generated SignedSource<<d10e3dc366cf224effcf61d2ccbcd043>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "bgProcessed" | "datamatics" | "large" | "master" | "medium" | "oldMaster" | "original" | "placeholder" | "small" | "thumb" | "transparent" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedLayout_viewer$data = {
  readonly isPdpUrlTranslationEnabled?: boolean | null;
  readonly itemRead: ReadonlyArray<{
    readonly activePromotion?: {
      readonly code: string | null;
    } | null;
    readonly attributes?: {
      readonly period: ReadonlyArray<{
        readonly option: {
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly browseUrl?: string | null;
    readonly categoryCode?: string | null;
    readonly contemporaryTrackingString?: string;
    readonly defaultSkuId?: string | null;
    readonly isAuctionEnabled?: boolean | null;
    readonly isMultiSku?: boolean;
    readonly isPriceUponRequest?: boolean | null;
    readonly localizedPdpUrl?: string | null;
    readonly microdata?: string | null;
    readonly pdpMeta?: {
      readonly description: string | null;
      readonly index: boolean | null;
      readonly ogTitle: string | null;
      readonly productPriceAmount: string | null;
      readonly productPriceCurrency: string | null;
      readonly title: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"getLanguageAnnotations_pdpMetaItems">;
    } | null;
    readonly pdpTrackingVpvParams?: any | null;
    readonly pdpURL?: string | null;
    readonly photos?: ReadonlyArray<{
      readonly versions: ReadonlyArray<{
        readonly type: {
          readonly name: ImageVersionTypeName | null;
        } | null;
        readonly webPath: string | null;
      } | null> | null;
    } | null> | null;
    readonly saveSearchData?: {
      readonly page: string | null;
    } | null;
    readonly seller?: {
      readonly isAccessible: boolean | null;
      readonly isInternal: boolean | null;
      readonly serviceId: string | null;
    } | null;
    readonly serviceId?: string | null;
    readonly skus?: ReadonlyArray<{
      readonly images: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
      readonly skuId: string | null;
    } | null> | null;
    readonly viewInRoomPhotos?: ReadonlyArray<{
      readonly src: string | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedOriginalLanguageProvider_item" | "pricingGuidanceTracking_item">;
  } | null> | null;
  readonly transactions?: {
    readonly edges?: ReadonlyArray<{
      readonly node: {
        readonly isCanceled: boolean | null;
        readonly isPrivateOffer: boolean | null;
        readonly skuId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useBuyerUrgency_viewer">;
  readonly " $fragmentType": "PdpSharedLayout_viewer";
};
export type PdpSharedLayout_viewer$key = {
  readonly " $data"?: PdpSharedLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RootArgument",
  "name": "priceBookName"
},
v1 = {
  "kind": "RootArgument",
  "name": "userCountryCode"
},
v2 = {
  "kind": "RootArgument",
  "name": "userId"
},
v3 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v4 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fdfQuoteABTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "forcedCurrency"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "RootArgument",
      "name": "userIds"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedLayout_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpUrlTranslationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedOriginalLanguageProvider_item"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "pricingGuidanceTracking_item",
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId"
                    },
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade"
                    },
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "concreteType": "PricingGuidance",
                  "kind": "LinkedField",
                  "name": "pricingGuidance",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "priceRange",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": [
                {
                  "kind": "RootArgument",
                  "name": "isTrade"
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ]
            },
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMultiSku",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultSkuId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAuctionEnabled",
              "storageKey": null
            },
            {
              "condition": "isClient",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "fdfQuoteABTestVariant",
                      "variableName": "fdfQuoteABTestVariant"
                    },
                    (v4/*: any*/),
                    (v6/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "userZipCode",
                      "variableName": "userZipCode"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "pdpTrackingVpvParams",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    (v6/*: any*/)
                  ],
                  "concreteType": "Promotion",
                  "kind": "LinkedField",
                  "name": "activePromotion",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SaveSearchDataType",
              "kind": "LinkedField",
              "name": "saveSearchData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "page",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "condition": "fetchPdp",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "currency",
                      "variableName": "forcedCurrency"
                    },
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "kind": "ScalarField",
                  "name": "microdata",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pdpURL",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "localizedPdpUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "pdpMetaItems",
                  "kind": "LinkedField",
                  "name": "pdpMeta",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "index",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ogTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "productPriceAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "productPriceCurrency",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "getLanguageAnnotations_pdpMetaItems",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LanguageAnnotations",
                          "kind": "LinkedField",
                          "name": "languageAnnotations",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hrefLang",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "href",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemPhoto",
                  "kind": "LinkedField",
                  "name": "photos",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ItemPhotoVersion",
                      "kind": "LinkedField",
                      "name": "versions",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "webPath",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ImageVersionType",
                          "kind": "LinkedField",
                          "name": "type",
                          "plural": false,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPriceUponRequest",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemAttributes",
                  "kind": "LinkedField",
                  "name": "attributes",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AttributeValue",
                      "kind": "LinkedField",
                      "name": "period",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AttributeOption",
                          "kind": "LinkedField",
                          "name": "option",
                          "plural": false,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Seller",
                  "kind": "LinkedField",
                  "name": "seller",
                  "plural": false,
                  "selections": [
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isInternal",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAccessible",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "viewInRoomPhotos",
                  "kind": "LinkedField",
                  "name": "viewInRoomPhotos",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "src",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contemporaryTrackingString",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSkuType",
              "kind": "LinkedField",
              "name": "skus",
              "plural": true,
              "selections": [
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemPhoto",
                  "kind": "LinkedField",
                  "name": "images",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemIds"
            }
          ],
          "concreteType": "TransactionConnection",
          "kind": "LinkedField",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "condition": "isMultiSku",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransactionEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Transaction",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isPrivateOffer",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCanceled",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        (v6/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "useBuyerUrgency_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "f8bbbb621b9ab974f909df1d777b3f37";

export default node;
